import * as React from 'react';
import { ThemeProvider } from 'styled-components';

import { Wrapper, Name, Position, Contact } from './styles';

interface UserInfoProps {
	name: string;
	position: string;
	email: string;
	phone: string;
	isSmall?: boolean;
}

const UserInfo = ({
	name,
	position,
	email,
	phone,
	isSmall,
}: UserInfoProps) => (
	<ThemeProvider theme={{ isSmall }}>
		<Wrapper>
			<Name>{name}</Name>
			<Position>{position}</Position>
			<Contact>{email}</Contact>
			<Contact>{phone}</Contact>
		</Wrapper>
	</ThemeProvider>
);

export default UserInfo;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProfilePage/UserInfo/index.tsx